var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cf5ee7c43de3c020eee8fb395a1270b8ee641e51"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["jems2-mjr-ui@fjorge"]={id:"cf5ee7c43de3c020eee8fb395a1270b8ee641e51"};
      